import jQuery from "jquery";
window.$ = window.jQuery = jQuery;
$(function () {
	function navToggle() {
		$("header nav").fadeToggle();
		$(".nav-button .close, .nav-button .open").toggle();
	}
	$(".back-button").on("click", function () {
		history.back();
	});
	$(".nav-button, header nav a").on("click", function () {
		navToggle();
	});
	$(".footer-copyright-year").text(new Date().getFullYear());

	//Social Media Sharing Widgets
	var shareTitle = encodeURI(document.title);
	var shareExcerpt = encodeURI(
		document.querySelector('meta[name="description"]').content
	);
	var shareUrl = encodeURI(window.location.href);
	var shareThumbnail = encodeURI(
		document.querySelector('meta[property="og:image"]').content
	);
	// The magic starts here:
	$("[data-media=facebook]").attr(
		"href",
		"https://www.facebook.com/sharer.php?u=" + shareUrl
	);
	$("[data-media=linkedin]").attr(
		"href",
		"https://www.linkedin.com/shareArticle?url=" +
			shareUrl +
			"&title=" +
			shareTitle
	);
	$("[data-media=twitter]").attr(
		"href",
		"https://twitter.com/share?url=" + shareUrl + "&text=" + shareTitle
	);
	$("[data-media=whatsapp]").attr(
		"href",
		"https://api.whatsapp.com/send?text=" + shareTitle + "%20" + shareUrl
	);
	$("[data-media=telegram]").attr(
		"href",
		"https://telegram.me/share/url?url=" + shareUrl + "&text=" + shareTitle
	);
	$("[data-media=pinterest]").attr(
		"href",
		"https://pinterest.com/pin/create/bookmarklet/?media=" +
			shareThumbnail +
			"&url=" +
			shareUrl +
			"&description=" +
			shareTitle
	);
	$("[data-media=reddit]").attr(
		"href",
		"https://reddit.com/submit?url=" + shareUrl + "&title=" + shareTitle
	);
	$("[data-media=weibo]").attr(
		"href",
		"https://service.weibo.com/share/share.php?url=" +
			shareUrl +
			"&title=" +
			shareTitle
	);
	$("[data-media=email]").attr(
		"href",
		"mailto:?subject=" + shareTitle + "&body=" + shareUrl + "%20" + shareExcerpt
	);
}); //Document Ready
